import HeaderNav from "./HeaderNav";

const Header = () => {
    return <header><HeaderNav /></header>
}

export default Header;